<template>
    <RowColumn :no-column-margin-top="true">
        <Breadcrumb :items="items"/>
    </RowColumn>
</template>

<script>
import Breadcrumb from "./html/Breadcrumb";
import RowColumn from "./RowColumn";

export default {
    name: "BreadcrumbRow",
    components: {RowColumn, Breadcrumb},
    props: ['items'],
}
</script>
